import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  setAccessToken,
  setRefreshToken,
  setMemberId,
  setMemberName,
  setMemberRole,
} from '../features/loginInfo/loginInfoSlice';
import { useLoginInfo } from 'hook/loginInfo';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { accessToken, memberName } = useSelector((state) => state.loginInfo);

  const loginInfo = useLoginInfo();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLogout = () => {
    // Clear Redux state
    dispatch(setAccessToken(null));
    dispatch(setRefreshToken(null));
    dispatch(setMemberId(null));
    dispatch(setMemberName(null));
    dispatch(setMemberRole(null));

    // Clear session storage
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('refreshToken');
    sessionStorage.removeItem('memberId');
    sessionStorage.removeItem('memberName');
    sessionStorage.removeItem('memberRole');

    toggleMenu();
    navigate('/'); // Navigate to home page after logout
  };

  return (
    <>
      <header className="common-header">
        <h1 className="header-logo">
          <Link to="/">Crizel</Link>
        </h1>
        <div className="header-utils">
          {accessToken && <span className="user-name">{loginInfo.memberName} 님</span>}
          <button className="menu-button" onClick={toggleMenu}>
            ☰
          </button>
        </div>
      </header>
      <nav className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
        <button className="close-button" onClick={toggleMenu}>
          &times;
        </button>
        <ul>
          {accessToken ? (
            <>
              <li><button onClick={handleLogout} className="logout-button">로그아웃</button></li>
              <li><Link to="/diary" onClick={toggleMenu}>Diary</Link></li>
              <li><Link to="/girls" onClick={toggleMenu}>Girls</Link></li>
              <li><Link to="/body" onClick={toggleMenu}>Body</Link></li>
            </>
          ) : (
            <li><Link to="/login" onClick={toggleMenu}>로그인</Link></li>
          )}
          <li><Link to="/food" onClick={toggleMenu}>Food</Link></li>
          <li><Link to="/gsFellowship" onClick={toggleMenu}>GS</Link></li>
          <li><Link to="/lotto" onClick={toggleMenu}>Lotto</Link></li>
        </ul>
      </nav>
      <div className={`overlay ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}></div>
    </>
  );
};

export default Header;
